import {h, Component} from 'preact'

export default class Card extends Component {
  render ({title, description, categories, link}) {
    return (
      <div class="card">
        {link &&
          <a href={link} title="Mehr erfahren" class="card-full-link"></a>
        }
        <div class="card-header bg-transparent">
            <h6 class="card-subtitle mb-2 text-muted">{categories.join(', ')}</h6>
            <h5 class="card-title text-primary">{title}</h5>
        </div>
        <div class="card-body">
            <p class="card-text">{description}</p>
        </div>
      </div>
    )
  }
}
